// iter158 (2026-07-07) — backwards-compat re-export.
// The file was renamed to `MailingListDashboard.js` because "Marketing
// Dashboard" now refers to the full-funnel analytics page at
// /admin/marketing (see `AdminMarketingDashboard.js`). Any existing
// import of `MarketingDashboard` from the CRM folder still works.
import MailingListDashboard from './MailingListDashboard';
export default MailingListDashboard;
